'use client'
import { MatchDetail } from '@/app/libs/match/types'
import { createContext, ReactNode, useContext, useState } from 'react'

const MatchContext = createContext<{
  setMatchDetail: (matchDetail: MatchDetail) => void
  matchDetail: MatchDetail
} | null>(null)

export default function MatchContextProvider({
  children,
  initialData
}: {
  children: ReactNode
  initialData: MatchDetail
}) {
  const [matchDetail, setMatchDetail] = useState<MatchDetail>(initialData)

  return (
    <MatchContext.Provider value={{ setMatchDetail, matchDetail }}>
      {children}
    </MatchContext.Provider>
  )
}

export function useMatchContext() {
  const context = useContext(MatchContext)
  if (!context) {
    throw new Error('useMatchContext must be used within a MatchContextProvider')
  }
  return context
}
